 
 import {RotatingLines } from 'react-loader-spinner'
 import css from './pageloader.css'
 function Pageloader() {
    return (
        <div class="loader"></div> 
    )
}

export default Pageloader;